<template>
  <div class="component-wrapper d-flex flex-column align-center">
    <Alert v-for="(alert, i) in alertsItems" :key="i" :items="alert"></Alert>
    <div class="container mb-16 elevation-2 mt-8">
      <div class="container__title white--text text-sm-body-1 pa-sm-5 pa-2">
        Εκθέσεις ΑΕΔΑΚ
      </div>
      <v-btn
        to="/hcmc/pending/reports"
        class="
          primary
          rounded
          button
          text-sm-body-1
          font-weight-regular
          ma-5
          button
        "
        >Προβολή εκκρεμών εκθέσεων</v-btn
      >
    </div>

    <div class="container elevation-2 mb-16">
      <div class="container__title white--text text-sm-body-1 pa-sm-5 pa-2">
        Αναφορές ESMA
      </div>
      <v-btn
        to="/hcmc/submitted/reports"
        class="
          primary
          rounded
          button
          text-sm-body-1
          font-weight-regular
          ma-5
          button
        "
        >Προβολή εκθέσεων που υπεβλήθησαν</v-btn
      >
    </div>
  </div>
</template>

<script>
import Alert from "../../components/Alert.vue";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    Alert,
  },

  async created() {
    try {
      await this.getMissingReports();
      this.missingReports.forEach((el) => {
        this.alertsItems.push({
          strong_text: "Σημαντικό! ",
          text: `Ο ΑΕΔΑΚ ${el.creditInstituteName} δεν έχει υποβάλει έκθεση για τη περίοδο ${el.reportPeriodName}`,
          text_color: "error",
          dismissable: true,
          width: "950px",
          button: "Αποστολή υπενθύμισης",
          body: {
            ReportPeriodId: el.reportPeriodId,
            CreditInstituteId: el.creditInstituteId,
            creditInstituteName: el.creditInstituteName,
          },
        });
      });
    } catch (e) {}
  },
  data() {
    return {
      alertsItems: [],
    };
  },

  computed: {
    ...mapState({
      missingReports: (state) => state.reports.missingReports,
    }),
  },

  methods: {
    ...mapActions(["getMissingReports"]),
  },
};
</script>

<style scoped lang="scss">
.container {
  width: 850px;

  &__title {
    background-color: var(--v-primary-base);
  }
}

.button {
  width: 350px !important;
}

@media only screen and (max-width: 960px) {
  .container {
    width: 100%;
  }
  .button {
    width: 300px !important;
  }
}
</style>